import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);

  // const role = sessionStorage.getItem('role') ?? null;
  const isBrowser = typeof document.defaultView?.sessionStorage !== 'undefined';
  const role = isBrowser
    ? document.defaultView?.sessionStorage?.getItem('role')
    : null;

  if (role !== 'doctorPayer' && role !== 'admin') {
    router.navigate(['/']); // Redirect to sign-in page
    return false;
  }

  return true;
};
